import { CheckIcon } from '../../components/ui/Icons';
import { Step } from './types';

interface StepIndicatorProps {
  step: Step;
  isAuthenticated: boolean;
}

const ALL_STEPS: { key: Step; label: string }[] = [
  { key: 'guest-info', label: 'Seus dados' },
  { key: 'payment', label: 'Pagamento' },
  { key: 'confirm', label: 'Confirmar' },
];

export function StepIndicator({ step, isAuthenticated }: StepIndicatorProps) {
  const steps = isAuthenticated ? ALL_STEPS.filter((s) => s.key !== 'guest-info') : ALL_STEPS;
  const currentIndex = Math.max(0, steps.findIndex((s) => s.key === step));

  return (
    <nav aria-label="Etapas do pedido" className="mb-4 sm:mb-6">
      <ol className="flex items-start">
        {steps.map((s, idx) => {
          const isDone = idx < currentIndex;
          const isCurrent = idx === currentIndex;
          return (
            <li
              key={s.key}
              aria-current={isCurrent ? 'step' : undefined}
              className="flex items-start flex-1 last:flex-none"
            >
              <div className="flex flex-col items-center">
                <span
                  className={[
                    'w-8 h-8 rounded-full flex items-center justify-center text-sm font-extrabold transition-colors',
                    isDone
                      ? 'bg-olivine-dark text-white'
                      : isCurrent
                      ? 'bg-chocolate-dark text-white shadow-md'
                      : 'bg-champagne text-text-medium',
                  ].join(' ')}
                >
                  {isDone ? <CheckIcon className="w-4 h-4" /> : idx + 1}
                </span>
                <span
                  className={[
                    'text-sm font-semibold mt-1.5 text-center whitespace-nowrap',
                    isCurrent ? 'text-chocolate-dark' : 'text-text-medium',
                  ].join(' ')}
                >
                  {s.label}
                  {isDone && <span className="sr-only"> (concluída)</span>}
                </span>
              </div>
              {idx < steps.length - 1 && (
                <span
                  aria-hidden="true"
                  className={[
                    'h-0.5 flex-1 mx-2 sm:mx-3 mt-4 rounded-full transition-colors',
                    isDone ? 'bg-olivine-dark' : 'bg-champagne-dark',
                  ].join(' ')}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
